import { NULL_UI_DEFAULT, type TNullUiValue } from '@dbl/core/chartEditor';
import type { IAxisPercentSeriesItem } from '@customComp/Chart/utils/axisPercent/types';
import { isNullDataPoint } from './isNullDataPoint';

type TLineSeriesDataPoint = IAxisPercentSeriesItem['data'][number];

/**
 * 按 null_ui 改写折线几何 value（不改 oPercent / Tooltip 数据源）。
 */
export function applyNullUiToPercentLineSeries<T extends IAxisPercentSeriesItem>(
  series: T[],
  nullUi?: TNullUiValue,
): T[] {
  const mode = nullUi ?? NULL_UI_DEFAULT;
  const connectNulls = mode === 'ignore';

  return series.map(seriesItem => ({
    ...seriesItem,
    connectNulls,
    data: seriesItem.data.map((point: TLineSeriesDataPoint) => {
      if (!isNullDataPoint(point.metricValue)) {
        return point;
      }
      if (mode === '0') {
        return { ...point, value: 0 };
      }
      return { ...point, value: null };
    }),
  }));
}
